// extracted by mini-css-extract-plugin
module.exports = {"container":"_1OR7t","input":"tC8Au","borders":"_3RT2J"};